<ng-container *transloco="let t; prefix: 'edit-person-modal'">

  <app-edit-modal-shell
    [title]="t('title', {personName: person().name})"
    [translocoPrefix]="'edit-person-modal'"
    [field]="formGroup"
    [(activeTabId)]="activeId"
    (close)="close()"
    (save)="save()"
  >

    <ng-template [appEditTab]="Tabs.General">
      <div class="row g-0">
        <div class="mb-3">
          <app-setting-item [title]="t('name-label')" [toggleOnViewClick]="false" [showEdit]="false" [control]="formGroup.name">
            <ng-template #view>
              <input class="form-control" [formField]="formGroup.name" type="text" [appFormField]="formGroup.name">
            </ng-template>
          </app-setting-item>
        </div>
      </div>

      <div class="row g-0">
        <div class="mb-3 col-md-6 col-xs-12 pe-2">
          <app-setting-item [title]="t('mal-id-label')" [toggleOnViewClick]="false" [showEdit]="false" [subtitle]="t('mal-tooltip' + tooltip())" [control]="formGroup.malId">
            <ng-template #view>
              <input class="form-control" [formField]="formGroup.malId" type="number" [appFormField]="formGroup.malId">
            </ng-template>
          </app-setting-item>
        </div>

        <div class="mb-3 col-md-6 col-xs-12">
          <app-setting-item [title]="t('anilist-id-label')" [toggleOnViewClick]="false" [showEdit]="false" [subtitle]="t('anilist-tooltip' + tooltip())" [control]="formGroup.aniListId">
            <ng-template #view>
              <input class="form-control" [formField]="formGroup.aniListId" type="number" [appFormField]="formGroup.aniListId">
            </ng-template>
          </app-setting-item>
        </div>
      </div>

      <div class="row g-0">
        <div class="mb-3 col-md-6 col-xs-12 pe-2">
          <app-setting-item [title]="t('hardcover-id-label')" [toggleOnViewClick]="false" [showEdit]="false" [subtitle]="t('hardcover-tooltip')" [control]="formGroup.hardcoverId">
            <ng-template #view>
              <input class="form-control" [formField]="formGroup.hardcoverId" type="text" [appFormField]="formGroup.hardcoverId">
            </ng-template>
          </app-setting-item>
        </div>

        <div class="mb-3 col-md-6 col-xs-12">
          <app-setting-item [title]="t('asin-label')" [toggleOnViewClick]="false" [showEdit]="false" [subtitle]="t('asin-tooltip')" [control]="formGroup.asin">
            <ng-template #view>
              <input id="asin" class="form-control" [formField]="formGroup.asin" type="text" [appFormField]="formGroup.asin">
            </ng-template>
          </app-setting-item>
        </div>
      </div>

      <div class="row g-0">
        <div class="mb-3 w-100">
          <app-setting-item [title]="t('description-label')" [toggleOnViewClick]="false" [showEdit]="false">
            <ng-template #view>
              <div class="input-group">
                <textarea id="description" class="form-control" [formField]="formGroup.description" rows="4"></textarea>
              </div>
            </ng-template>
          </app-setting-item>
        </div>
      </div>
    </ng-template>

    <ng-template [appEditTab]="Tabs.Aliases">
      <h5>{{t('aliases-label')}}</h5>
      <div class="text-muted mb-2">{{t('aliases-tooltip')}}</div>
      <app-edit-list [items]="formGroup.aliases().value()"
                     [asyncItemValidator]="aliasValidator"
                     (updateItems)="updateAliases($event)"
                     [messages]="{'invalidAlias': t('alias-overlap')}"
                     [label]="t('aliases-label')"/>
    </ng-template>

    <ng-template [appEditTab]="Tabs.CoverImage">
      <p class="alert alert-primary" role="alert">
        {{t('cover-image-description')}}
        {{t('cover-image-description-extra')}}
      </p>

      <app-cover-image-chooser [config]="chooserConfig()" (coverChanged)="handleCoverChanged($event)" (resetClicked)="handleReset()" />
    </ng-template>

  </app-edit-modal-shell>

</ng-container>
